import { IconContent } from '@icons';

export const reportsV2: IconContent = {
    md: '<path d="M4 4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4Zm2 0H5v16h14V4H6Zm.5 6h1v4h-1v-4ZM10 8H9v6h1V8Zm1.5 1.5h1V14h-1V9.5ZM15 11h-1v3h1v-3Zm1.5 1h1v2h-1v-2Zm1.5 3H6v1h12v-1Z" />',
};
